import { render, staticRenderFns } from "./SendSolutionBanner.vue?vue&type=template&id=115ce2a8&scoped=true&"
import script from "./SendSolutionBanner.vue?vue&type=script&lang=ts&"
export * from "./SendSolutionBanner.vue?vue&type=script&lang=ts&"
import style0 from "./SendSolutionBanner.vue?vue&type=style&index=0&id=115ce2a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115ce2a8",
  null
  
)

export default component.exports